import React from "react";
import { createMatchesFromTeams } from "services/matchService";
import * as Sentry from "@sentry/react";

const CreateMatchesButton = ({ tournament, onCreated }) => {
  const handleClick = async () => {
    if (!tournament || !tournament.teams || Object.keys(tournament.teams).length === 0) {
      alert("Tournoi ou équipes non valides.");
      return;
    }

    try {
      await createMatchesFromTeams(tournament);
      onCreated?.(); // optional callback
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur lors de la création des matchs :", error);
      alert("❌ Une erreur est survenue lors de la création des matchs.");
    }
  };

  return (
    <button
      onClick={handleClick}
      className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 font-bold"
    >
      Créer les matchs
    </button>
  );
};

export default CreateMatchesButton;
